import React from "react";

import Tag from "antd/es/tag";
import type Calendar from "nylas/lib/models/calendar";
import { useIntl } from "react-intl";

import styles from "./AddEventToNylasModal.module.scss";

interface Props {
  calendar: Calendar;
}

const TargetCalendarAndInfo: React.FC<Props> = ({ calendar }) => {
  const intl = useIntl();
  return (
    <div>
      <p>
        {intl.formatMessage(
          {
            id: "dealRecord.addEventToNylasModal.calendar",
            defaultMessage: "Your calendar: {calendar}",
            description: "You calendar block in the add-event-to-nylas modal in Deal preview pane",
          },
          {
            calendar: <Tag className={styles.calendarName}>{calendar.name}</Tag>,
          }
        )}
      </p>
      <p>
        {intl.formatMessage({
          id: "dealRecord.addEventToNylasModal.text1",
          defaultMessage:
            "This close date will appear as an event in your integrated calendar at 9 a.m. local time.",
          description: "Text block 1 in the add-event-to-nylas modal in Deal preview pane",
        })}
      </p>
      <p>
        {intl.formatMessage({
          id: "dealRecord.addEventToNylasModal.text2",
          defaultMessage:
            "Please note, modifications to this event in your calendar will not change the close date in Map My Customers, even if two-way sync is enabled in your calendar sync settings.",
          description: "Text block 2 in the add-event-to-nylas modal in Deal preview pane",
        })}
      </p>
    </div>
  );
};

export default TargetCalendarAndInfo;
